var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search" },
        [
          _c(
            "el-form",
            {
              ref: "routeQueryForm",
              attrs: { model: _vm.routeQueryForm, inline: true, size: "mini" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "线路名称", prop: "routeName" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入内容" },
                    model: {
                      value: _vm.routeQueryForm.routeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.routeQueryForm, "routeName", $$v)
                      },
                      expression: "routeQueryForm.routeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "出发城市", prop: "startCityId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        "filter-method": _vm.filterRegionData,
                        placeholder: "请选择",
                      },
                      on: { focus: _vm.resetStartAreaManager },
                      model: {
                        value: _vm.startAreaManageName,
                        callback: function ($$v) {
                          _vm.startAreaManageName = $$v
                        },
                        expression: "startAreaManageName",
                      },
                    },
                    [
                      _c(
                        "el-option",
                        {
                          staticStyle: { height: "auto" },
                          attrs: {
                            value: _vm.routeQueryForm.startAreaManageId,
                          },
                        },
                        [
                          _c("el-tree", {
                            ref: "startAreaManagerTree",
                            staticClass: "filter-tree",
                            attrs: {
                              props: _vm.regionProps,
                              data: _vm.startAreaTreeData,
                              "filter-node-method": _vm.filterRegionTreeNode,
                            },
                            on: { "node-click": _vm.handleNodeClick },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "目的城市", prop: "endCityId" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        "filter-method": _vm.filterEndRegionData,
                        placeholder: "请选择",
                      },
                      on: { focus: _vm.resetEndAreaManager },
                      model: {
                        value: _vm.endAreaManageName,
                        callback: function ($$v) {
                          _vm.endAreaManageName = $$v
                        },
                        expression: "endAreaManageName",
                      },
                    },
                    [
                      _c(
                        "el-option",
                        {
                          staticStyle: { height: "auto" },
                          attrs: { value: _vm.routeQueryForm.endAreaManageId },
                        },
                        [
                          _c("el-tree", {
                            ref: "endAreaManagerTree",
                            staticClass: "filter-tree",
                            attrs: {
                              props: _vm.regionProps,
                              data: _vm.endAreaTreeData,
                              "filter-node-method": _vm.filterEndRegionTreeNode,
                            },
                            on: { "node-click": _vm.handleEndNodeClick },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "出发站点", prop: "startStationId" } },
                [
                  _c("yd-common-selector", {
                    attrs: {
                      placeholder: "请输入关键字查找线路名称",
                      options: _vm.startStationNameList,
                    },
                    model: {
                      value: _vm.routeQueryForm.startStationId,
                      callback: function ($$v) {
                        _vm.$set(_vm.routeQueryForm, "startStationId", $$v)
                      },
                      expression: "routeQueryForm.startStationId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "目的站点", prop: "endStationId" } },
                [
                  _c("yd-common-selector", {
                    attrs: {
                      placeholder: "请输入关键字查找线路名称",
                      options: _vm.endStationNameList,
                    },
                    model: {
                      value: _vm.routeQueryForm.endStationId,
                      callback: function ($$v) {
                        _vm.$set(_vm.routeQueryForm, "endStationId", $$v)
                      },
                      expression: "routeQueryForm.endStationId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "线路类型", prop: "routeTypeId" } },
                [
                  _c("yd-common-selector", {
                    attrs: { options: _vm.options },
                    model: {
                      value: _vm.routeQueryForm.routeTypeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.routeQueryForm, "routeTypeId", $$v)
                      },
                      expression: "routeQueryForm.routeTypeId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c("yd-common-selector", {
                    attrs: { options: _vm.stateOptions },
                    model: {
                      value: _vm.routeQueryForm.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.routeQueryForm, "status", $$v)
                      },
                      expression: "routeQueryForm.status",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        loading: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.getRoteListPage(1)
                        },
                      },
                    },
                    [_vm._v("筛选")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        icon: "el-icon-delete",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.clearRouteForm },
                    },
                    [_vm._v("清空")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", [
        _c(
          "div",
          { staticClass: "refund-table" },
          [
            _c(
              "yd-table",
              {
                attrs: {
                  data: _vm.routeDataTable,
                  loading: _vm.loading,
                  pagination: _vm.pages,
                },
                on: { onChange: _vm.onTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["transport_route_add"],
                                expression: "['transport_route_add']",
                              },
                            ],
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.jumpUrl("/route")
                              },
                            },
                          },
                          [_vm._v("新增线路")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.handleOperateLog },
                          },
                          [_vm._v("操作日志")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "id",
                    width: "60",
                    label: "ID",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: "线路名称",
                    prop: "lineName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: "出发城市",
                    prop: "startCityName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: "目的城市",
                    prop: "endCityName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: "出发地址",
                    prop: "startAddress",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: "到达地址",
                    prop: "endAddress",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: "行程时长",
                    prop: "durationStr",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: "总里程数（公里）",
                    prop: "mileage",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: "线路类型",
                    prop: "typeStr",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": true,
                    label: "状态",
                    prop: "status",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.status === 1
                            ? _c(
                                "el-tag",
                                { attrs: { size: "mini", type: "success" } },
                                [_vm._v("正常")]
                              )
                            : _vm._e(),
                          scope.row.status === 2
                            ? _c(
                                "el-tag",
                                { attrs: { size: "mini", type: "info" } },
                                [_vm._v("下架")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["transport_route_info"],
                                      expression: "['transport_route_info']",
                                    },
                                  ],
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getRouteInfo(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("详情")]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["transport_route_edit"],
                                      expression: "['transport_route_edit']",
                                    },
                                  ],
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editRoute("/route", scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.status === 1,
                                      expression: "scope.row.status === 1",
                                    },
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["transport_route_dow"],
                                      expression: "['transport_route_dow']",
                                    },
                                  ],
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.checkRouteStatus(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("下架")]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.status === 2,
                                      expression: "scope.row.status === 2",
                                    },
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["transport_route_up"],
                                      expression: "['transport_route_up']",
                                    },
                                  ],
                                  attrs: { size: "mini", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.checkRouteStatus(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("上架")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm.showDrawerVisible
        ? _c("route-set-info", {
            ref: "routeSetInfo",
            on: { onUrlChange: _vm.jumpUrl },
          })
        : _vm._e(),
      _c("OperateLog", {
        attrs: { visible: _vm.operateVisible, active: "line" },
        on: { close: _vm.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }